import { useTranslation } from 'react-i18next'
import { useAuth } from '@/context/AuthContext'
import { Chip } from '@/components/aurora'
import { Sparkles } from 'lucide-react'

export default function WelcomeBanner() {
  const { t }      = useTranslation()
  const { user }   = useAuth()

  const firstName =
    user?.full_name?.split(' ')[0]
    || user?.username
    || t('dashboard.student', 'student')

  return (
    <div
      className="rounded-2xl border px-6 py-7 sm:px-8 sm:py-8 relative overflow-hidden"
      style={{ background: 'var(--coral-tint)', borderColor: 'var(--coral-soft)' }}
    >
      <div
        className="absolute -top-12 -right-12 w-40 h-40 rounded-full opacity-20 pointer-events-none"
        style={{ background: 'radial-gradient(circle, var(--coral) 0%, transparent 70%)' }}
      />

      <div className="relative">
        <Chip variant="new" className="mb-3">
          <Sparkles size={11} strokeWidth={2}/> {t('dashboard.welcome', 'Xush kelibsiz')}
        </Chip>

        <h1 className="m-0 font-display text-[32px] sm:text-[42px] leading-tight tracking-tight" style={{ color: 'var(--ink)' }}>
          {t('dashboard.hello', 'Salom')},{' '}
          <em className="not-italic font-black" style={{ color: 'var(--coral)' }}>
            {firstName}
          </em>
        </h1>

        <p className="text-[14.5px] mt-2 mb-4 max-w-lg leading-relaxed" style={{ color: 'var(--ink-2)' }}>
          {t('dashboard.welcomeMessage', "Bugun nima qilamiz? Pastda yangi materiallar mavjud.")}
        </p>
      </div>
    </div>
  )
}
